<!--页脚-->
<template>
    <div class="breadcrumb-body" role="navigation">
        您的位置： <router-link href="#" to="/">首页</router-link>
         > <router-link href="#" :to="secondhref">{{secondtest}}</router-link>
      <a v-if='thirdtest'>
         > <router-link href="#" :to="thirdhref">{{thirdtest}}</router-link>
      </a>
      <a v-if='fourthtest'>
        > <router-link href="#" :to="fourthhref">{{fourthtest}}</router-link>
      </a>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  props: ['secondhref', 'thirdhref', 'fourthhref', 'secondtest', 'thirdtest', 'fourthtest'],
  data () {
    return {
    }
  }
}
</script>

<style>
  .breadcrumb-body{
    width: 950px;
    margin: 0px auto;
    padding-left: 15px;
    padding-top: 12px;
    padding-bottom: 0px;
    font-size: 11px;
    color: #999999;
  }
  .breadcrumb-body a {
    color: #999999;
  }
</style>



// WEBPACK FOOTER //
// src/components/breadcrumb/breadcrumb.vue